import React from 'react'
import { connect } from 'react-redux'
import { Icon } from '@yapay/design-system'
import Safe from './Safe'
import Logo from './Logo'

export const CardChallengeCompleted = () => {
  return (
    <div>
      <header className="flex items-center justify-between px-4 pt-4 lg:px-12 lg:pt-8">
        <Logo />
        <Safe />
      </header>

      <br />
      <h2>Pagamento em andamento!</h2>

      <div className="flex items-center">
        <div className="mr-4">
          <Icon
            icon="transfer"
            width="50"
            height="50"
            className="fill-current text-gray-600"
          />
        </div>
        <p className="m-0">
          Autenticação concluída! Você já pode fechar essa janela.
        </p>
      </div>

      <div className="flex items-center">
        <div className="mr-4">
          <Icon
            icon="mail"
            width="50"
            height="50"
            className="fill-current text-gray-600"
          />
        </div>
        <p className="m-0">
          Você será informado por e-mail sobre o andamento do pedido.
        </p>
      </div>
    </div>
  )
}

const mapStateToProps = state => state

export default connect(mapStateToProps)(CardChallengeCompleted)
